import React, { useState } from "react";
import FlipperVaultHeader from "../../stories/common/flipper-vault-header";
import styles from "./index.module.scss";
import ListView from "./ListView";
import GridView from "./GridView";
import MapSection from "./map-section";
import HRCardListing from "./horizontal-card-listing";
import WebListView from "./web-list-view";

export default function FlipperVault() {
  const [listView, setListView] = React.useState(true);
  const [mostVisibleCard, setMostVisibleCard] = useState<string | null>(null);

  return (
    <div className={styles.entityMap}>
      <FlipperVaultHeader listView={listView} setListView={setListView} />

      {listView ? (
        <>
          <div className={styles.flipperVaultWebWrapper}>
            <MapSection visibleCardId={mostVisibleCard} />
            <div className={styles.flipperVaultWebList}>
              <WebListView setMostVisibleCard={setMostVisibleCard} />
            </div>
          </div>
          <HRCardListing>
            <GridView
              mostVisibleCard={mostVisibleCard}
              setMostVisibleCard={setMostVisibleCard}
            />
          </HRCardListing>
        </>
      ) : (
        <ListView />
      )}
    </div>
  );
}
